import React, { useState, useEffect } from 'react';
import {
  SHELL_THEMES,
  getStoredShellTheme,
  getShellThemeLabel,
  isSelectableShellTheme,
} from '../../utils/shellTheme';
import { saveUiPreferencePatch, UI_PREFERENCES_EVENT } from '../../utils/uiPreferences';
import './ThemePickers.css';

/**
 * Backdrop (page gutter) color picker — curated short list.
 * Saves to DB (cross-browser) + localStorage cache.
 */
export default function ShellThemePicker({ compact = false, layout = 'compact' }) {
  const mode = layout === 'page' ? 'page' : (compact ? 'compact' : 'compact');
  const [theme, setTheme] = useState(getStoredShellTheme);

  useEffect(() => {
    const sync = () => setTheme(getStoredShellTheme());
    sync();
    window.addEventListener('storage', sync);
    window.addEventListener(UI_PREFERENCES_EVENT, sync);
    return () => {
      window.removeEventListener('storage', sync);
      window.removeEventListener(UI_PREFERENCES_EVENT, sync);
    };
  }, []);

  const select = (id) => {
    setTheme(id);
    saveUiPreferencePatch({ shell_theme: id });
  };

  const currentLabel = getShellThemeLabel(theme);
  const legacyNote = !isSelectableShellTheme(theme)
    ? ' (pick a backdrop below to update)'
    : '';

  return (
    <div className={`shell-theme-picker shell-theme-picker--${mode}`}>
      <div className="shell-theme-picker-label">Backdrop</div>
      <div className="shell-theme-picker-swatches" role="listbox" aria-label="Backdrop">
        {SHELL_THEMES.map((t) => (
          <button
            key={t.id}
            type="button"
            role="option"
            aria-selected={theme === t.id}
            className={`shell-theme-dot shell-theme-dot--${t.id}${theme === t.id ? ' active' : ''}`}
            onClick={(e) => {
              e.stopPropagation();
              select(t.id);
            }}
            title={t.label}
            aria-label={t.label}
          />
        ))}
      </div>
      <div className="shell-theme-picker-current">
        {currentLabel}{legacyNote}
      </div>
    </div>
  );
}
